/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkUserProvisionRequest,
  BulkUserProvisionResponse,
  CreateLocalUserRequest,
  PasswordResetRequest,
  PasswordResetResponse,
  UpdateUserRequest,
  UserListResponse,
  UserResponse,
} from '../models/index';
import {
    BulkUserProvisionRequestFromJSON,
    BulkUserProvisionRequestToJSON,
    BulkUserProvisionResponseFromJSON,
    BulkUserProvisionResponseToJSON,
    CreateLocalUserRequestFromJSON,
    CreateLocalUserRequestToJSON,
    PasswordResetRequestFromJSON,
    PasswordResetRequestToJSON,
    PasswordResetResponseFromJSON,
    PasswordResetResponseToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
    UserListResponseFromJSON,
    UserListResponseToJSON,
    UserResponseFromJSON,
    UserResponseToJSON,
} from '../models/index';

export interface ActivateUserRequest {
    id: string;
    sessionId?: string;
}

export interface BulkProvisionUsersRequest {
    bulkUserProvisionRequest: BulkUserProvisionRequest;
    sessionId?: string;
}

export interface CreateLocalUserOperationRequest {
    createLocalUserRequest: CreateLocalUserRequest;
    sessionId?: string;
}

export interface DeactivateUserRequest {
    id: string;
    sessionId?: string;
}

export interface DeleteUserRequest {
    id: string;
    sessionId?: string;
}

export interface GetUserRequest {
    id: string;
    sessionId?: string;
}

export interface GetUserProfileRequest {
    sessionId?: string;
}

export interface GetUserTimezoneRequest {
    id: string;
    sessionId?: string;
}

export interface GetUsersRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    email?: string;
    isActive?: boolean;
    sessionId?: string;
}

export interface ResetUserPasswordRequest {
    id: string;
    passwordResetRequest: PasswordResetRequest;
    sessionId?: string;
}

export interface UpdateUserOperationRequest {
    id: string;
    updateUserRequest: UpdateUserRequest;
    sessionId?: string;
}

export interface UpdateUserProfileRequest {
    updateUserRequest: UpdateUserRequest;
    sessionId?: string;
}

export interface UpdateUserTimezoneRequest {
    id: string;
    timezoneId: string;
    sessionId?: string;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * Activates a user account, enabling access to the system.  **What this does:** - Sets user.isActive = true - Activates all user-tenant associations - Enables user to authenticate and access the system  **Use cases:** - Reactivate a previously deactivated user - Approve a pending user account - Restore access after temporary suspension  **Note:** For SSO users, activation in the identity provider is managed separately. This endpoint controls access within this application. 
     * @summary Activate user
     * @param {string} id User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    activateUserRaw(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Activates a user account, enabling access to the system.  **What this does:** - Sets user.isActive = true - Activates all user-tenant associations - Enables user to authenticate and access the system  **Use cases:** - Reactivate a previously deactivated user - Approve a pending user account - Restore access after temporary suspension  **Note:** For SSO users, activation in the identity provider is managed separately. This endpoint controls access within this application. 
     * Activate user
     */
    activateUser(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Provisions multiple users in bulk for the specified tenant.  This endpoint allows administrators to create multiple users at once, which is useful for onboarding new team members or importing users from external systems.  **Features:** - Creates users with local authentication (Keycloak) - Assigns default roles automatically - Skips existing users (configurable) - Returns detailed results for each user  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * @summary Bulk provision users
     * @param {BulkUserProvisionRequest} bulkUserProvisionRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    bulkProvisionUsersRaw(requestParameters: BulkProvisionUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUserProvisionResponse>>;

    /**
     * Provisions multiple users in bulk for the specified tenant.  This endpoint allows administrators to create multiple users at once, which is useful for onboarding new team members or importing users from external systems.  **Features:** - Creates users with local authentication (Keycloak) - Assigns default roles automatically - Skips existing users (configurable) - Returns detailed results for each user  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Bulk provision users
     */
    bulkProvisionUsers(requestParameters: BulkProvisionUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUserProvisionResponse>;

    /**
     * Creates a single local authentication user in the specified tenant.  **What this does:** - Creates a user with local authentication (Keycloak) - Generates a secure password automatically - Assigns roles/groups based on request or tenant configuration - Sets preferred username/display name (or extracts from email if not provided) - Returns the generated password in the response for admin to share with user  **Password Handling:** - Passwords are NOT stored in this application\'s database - Passwords are only stored in Keycloak (identity provider) - The generated password is returned ONCE in the response - Supports temporary passwords (force reset on first login)  **Role Assignment (Optional, Mutually Exclusive with Groups):** - **Direct Role Assignment:** Provide `roleId` or `roleName` to assign a specific role - **Group-Based Assignment:** Provide `groupId` or `groupName` to add user to a group (inherits group roles) - **Default Assignment:** If no role/group specified, assigns tenant\'s default role - **Mutually Exclusive:** Cannot specify both role assignment AND group assignment in the same request - Priority: roleId > roleName > default  **Preferred Username (Optional):** - **Custom Username:** Provide `preferredUsername` to set a display name/username (e.g., \"jdoe\") - **Auto-Generated:** If not provided, extracts username from email (part before @) - Used for display purposes and can differ from email address  **Phone Number (Optional):** - **E.164 Format:** Provide `phoneNumber` in E.164 international format (e.g., \"+1-202-555-0173\", \"+44-20-7946-0958\") - **Validation:** Automatically normalized and validated - **Format:** +[country code][number] (hyphens/spaces allowed in input, normalized in storage)  **Extended Metadata (Optional):** - **Custom Fields:** Provide `metadata` as JSON object for tenant-specific custom fields - **Examples:** {\"department\": \"Engineering\", \"employeeId\": \"EMP-12345\", \"location\": \"New York\"} - **Storage:** Stored as JSONB in database for flexible schema extension  **Timezone Configuration (Optional):** - **Custom Timezone:** Provide `preferredTimezone` to override tenant default (e.g., \"America/New_York\") - **Tenant Default:** If not provided, uses tenant\'s configured default timezone - **System Default:** Falls back to UTC if tenant has no configured default  **Temporary Password Option:** - Set `temporaryPassword: true` to force password reset on first login - Set `temporaryPassword: false` (default) for permanent password  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * @summary Create local user
     * @param {CreateLocalUserRequest} createLocalUserRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createLocalUserRaw(requestParameters: CreateLocalUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Creates a single local authentication user in the specified tenant.  **What this does:** - Creates a user with local authentication (Keycloak) - Generates a secure password automatically - Assigns roles/groups based on request or tenant configuration - Sets preferred username/display name (or extracts from email if not provided) - Returns the generated password in the response for admin to share with user  **Password Handling:** - Passwords are NOT stored in this application\'s database - Passwords are only stored in Keycloak (identity provider) - The generated password is returned ONCE in the response - Supports temporary passwords (force reset on first login)  **Role Assignment (Optional, Mutually Exclusive with Groups):** - **Direct Role Assignment:** Provide `roleId` or `roleName` to assign a specific role - **Group-Based Assignment:** Provide `groupId` or `groupName` to add user to a group (inherits group roles) - **Default Assignment:** If no role/group specified, assigns tenant\'s default role - **Mutually Exclusive:** Cannot specify both role assignment AND group assignment in the same request - Priority: roleId > roleName > default  **Preferred Username (Optional):** - **Custom Username:** Provide `preferredUsername` to set a display name/username (e.g., \"jdoe\") - **Auto-Generated:** If not provided, extracts username from email (part before @) - Used for display purposes and can differ from email address  **Phone Number (Optional):** - **E.164 Format:** Provide `phoneNumber` in E.164 international format (e.g., \"+1-202-555-0173\", \"+44-20-7946-0958\") - **Validation:** Automatically normalized and validated - **Format:** +[country code][number] (hyphens/spaces allowed in input, normalized in storage)  **Extended Metadata (Optional):** - **Custom Fields:** Provide `metadata` as JSON object for tenant-specific custom fields - **Examples:** {\"department\": \"Engineering\", \"employeeId\": \"EMP-12345\", \"location\": \"New York\"} - **Storage:** Stored as JSONB in database for flexible schema extension  **Timezone Configuration (Optional):** - **Custom Timezone:** Provide `preferredTimezone` to override tenant default (e.g., \"America/New_York\") - **Tenant Default:** If not provided, uses tenant\'s configured default timezone - **System Default:** Falls back to UTC if tenant has no configured default  **Temporary Password Option:** - Set `temporaryPassword: true` to force password reset on first login - Set `temporaryPassword: false` (default) for permanent password  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Create local user
     */
    createLocalUser(requestParameters: CreateLocalUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Deactivates a user account, preventing access to the system.  **What this does:** - Sets user.isActive = false - Deactivates all user-tenant associations - Prevents user from authenticating and accessing the system - Existing sessions may remain valid until they expire  **Use cases:** - Temporarily suspend user access - Disable account for security reasons - Remove access without deleting the user record  **Protection:** - Protected system users cannot be deactivated - Deactivation is audited for compliance  **Note:** For SSO users, deactivation in the identity provider is managed separately. This endpoint controls access within this application. To fully prevent SSO users from accessing the system, they must also be disabled in their identity provider. 
     * @summary Deactivate user
     * @param {string} id User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    deactivateUserRaw(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Deactivates a user account, preventing access to the system.  **What this does:** - Sets user.isActive = false - Deactivates all user-tenant associations - Prevents user from authenticating and accessing the system - Existing sessions may remain valid until they expire  **Use cases:** - Temporarily suspend user access - Disable account for security reasons - Remove access without deleting the user record  **Protection:** - Protected system users cannot be deactivated - Deactivation is audited for compliance  **Note:** For SSO users, deactivation in the identity provider is managed separately. This endpoint controls access within this application. To fully prevent SSO users from accessing the system, they must also be disabled in their identity provider. 
     * Deactivate user
     */
    deactivateUser(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Deletes a user
     * @summary Delete user
     * @param {string} id User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a user
     * Delete user
     */
    deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a specific user by ID
     * @summary Get user by ID
     * @param {string} id User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Retrieves a specific user by ID
     * Get user by ID
     */
    getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Retrieves the current user\'s profile
     * @summary Get user profile
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserProfileRaw(requestParameters: GetUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Retrieves the current user\'s profile
     * Get user profile
     */
    getUserProfile(requestParameters: GetUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Retrieves user\'s preferred timezone
     * @summary Get user timezone
     * @param {string} id User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserTimezoneRaw(requestParameters: GetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves user\'s preferred timezone
     * Get user timezone
     */
    getUserTimezone(requestParameters: GetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves paginated list of users for the current tenant
     * @summary Get users
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [email] Email filter
     * @param {boolean} [isActive] Active status filter
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserListResponse>>;

    /**
     * Retrieves paginated list of users for the current tenant
     * Get users
     */
    getUsers(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserListResponse>;

    /**
     * Resets a user\'s password.  **Local Authentication:** - Generates a new secure password (or uses provided password) - Updates password in identity provider (Keycloak) - Returns the new password in the response  **SSO Users:** - Password reset is not available for SSO users - Password management is handled by the identity provider (Azure AD, Okta, Google, etc.) - Users must reset passwords through their organization\'s SSO portal  **Security:** - Requires users:update permission - All password resets are audited - Passwords can be marked as temporary (force reset on next login) 
     * @summary Reset user password
     * @param {string} id User ID
     * @param {PasswordResetRequest} passwordResetRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    resetUserPasswordRaw(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordResetResponse>>;

    /**
     * Resets a user\'s password.  **Local Authentication:** - Generates a new secure password (or uses provided password) - Updates password in identity provider (Keycloak) - Returns the new password in the response  **SSO Users:** - Password reset is not available for SSO users - Password management is handled by the identity provider (Azure AD, Okta, Google, etc.) - Users must reset passwords through their organization\'s SSO portal  **Security:** - Requires users:update permission - All password resets are audited - Passwords can be marked as temporary (force reset on next login) 
     * Reset user password
     */
    resetUserPassword(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordResetResponse>;

    /**
     * Updates user information
     * @summary Update user
     * @param {string} id User ID
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Updates user information
     * Update user
     */
    updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Updates the current user\'s profile
     * @summary Update user profile
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUserProfileRaw(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Updates the current user\'s profile
     * Update user profile
     */
    updateUserProfile(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

    /**
     * Updates user\'s preferred timezone
     * @summary Update user timezone
     * @param {string} id User ID
     * @param {string} timezoneId Timezone ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUserTimezoneRaw(requestParameters: UpdateUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>>;

    /**
     * Updates user\'s preferred timezone
     * Update user timezone
     */
    updateUserTimezone(requestParameters: UpdateUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * Activates a user account, enabling access to the system.  **What this does:** - Sets user.isActive = true - Activates all user-tenant associations - Enables user to authenticate and access the system  **Use cases:** - Reactivate a previously deactivated user - Approve a pending user account - Restore access after temporary suspension  **Note:** For SSO users, activation in the identity provider is managed separately. This endpoint controls access within this application. 
     * Activate user
     */
    async activateUserRaw(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling activateUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}/activate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Activates a user account, enabling access to the system.  **What this does:** - Sets user.isActive = true - Activates all user-tenant associations - Enables user to authenticate and access the system  **Use cases:** - Reactivate a previously deactivated user - Approve a pending user account - Restore access after temporary suspension  **Note:** For SSO users, activation in the identity provider is managed separately. This endpoint controls access within this application. 
     * Activate user
     */
    async activateUser(requestParameters: ActivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.activateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provisions multiple users in bulk for the specified tenant.  This endpoint allows administrators to create multiple users at once, which is useful for onboarding new team members or importing users from external systems.  **Features:** - Creates users with local authentication (Keycloak) - Assigns default roles automatically - Skips existing users (configurable) - Returns detailed results for each user  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Bulk provision users
     */
    async bulkProvisionUsersRaw(requestParameters: BulkProvisionUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUserProvisionResponse>> {
        if (requestParameters['bulkUserProvisionRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUserProvisionRequest',
                'Required parameter "bulkUserProvisionRequest" was null or undefined when calling bulkProvisionUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/users/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUserProvisionRequestToJSON(requestParameters['bulkUserProvisionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUserProvisionResponseFromJSON(jsonValue));
    }

    /**
     * Provisions multiple users in bulk for the specified tenant.  This endpoint allows administrators to create multiple users at once, which is useful for onboarding new team members or importing users from external systems.  **Features:** - Creates users with local authentication (Keycloak) - Assigns default roles automatically - Skips existing users (configurable) - Returns detailed results for each user  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Bulk provision users
     */
    async bulkProvisionUsers(requestParameters: BulkProvisionUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUserProvisionResponse> {
        const response = await this.bulkProvisionUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a single local authentication user in the specified tenant.  **What this does:** - Creates a user with local authentication (Keycloak) - Generates a secure password automatically - Assigns roles/groups based on request or tenant configuration - Sets preferred username/display name (or extracts from email if not provided) - Returns the generated password in the response for admin to share with user  **Password Handling:** - Passwords are NOT stored in this application\'s database - Passwords are only stored in Keycloak (identity provider) - The generated password is returned ONCE in the response - Supports temporary passwords (force reset on first login)  **Role Assignment (Optional, Mutually Exclusive with Groups):** - **Direct Role Assignment:** Provide `roleId` or `roleName` to assign a specific role - **Group-Based Assignment:** Provide `groupId` or `groupName` to add user to a group (inherits group roles) - **Default Assignment:** If no role/group specified, assigns tenant\'s default role - **Mutually Exclusive:** Cannot specify both role assignment AND group assignment in the same request - Priority: roleId > roleName > default  **Preferred Username (Optional):** - **Custom Username:** Provide `preferredUsername` to set a display name/username (e.g., \"jdoe\") - **Auto-Generated:** If not provided, extracts username from email (part before @) - Used for display purposes and can differ from email address  **Phone Number (Optional):** - **E.164 Format:** Provide `phoneNumber` in E.164 international format (e.g., \"+1-202-555-0173\", \"+44-20-7946-0958\") - **Validation:** Automatically normalized and validated - **Format:** +[country code][number] (hyphens/spaces allowed in input, normalized in storage)  **Extended Metadata (Optional):** - **Custom Fields:** Provide `metadata` as JSON object for tenant-specific custom fields - **Examples:** {\"department\": \"Engineering\", \"employeeId\": \"EMP-12345\", \"location\": \"New York\"} - **Storage:** Stored as JSONB in database for flexible schema extension  **Timezone Configuration (Optional):** - **Custom Timezone:** Provide `preferredTimezone` to override tenant default (e.g., \"America/New_York\") - **Tenant Default:** If not provided, uses tenant\'s configured default timezone - **System Default:** Falls back to UTC if tenant has no configured default  **Temporary Password Option:** - Set `temporaryPassword: true` to force password reset on first login - Set `temporaryPassword: false` (default) for permanent password  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Create local user
     */
    async createLocalUserRaw(requestParameters: CreateLocalUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['createLocalUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createLocalUserRequest',
                'Required parameter "createLocalUserRequest" was null or undefined when calling createLocalUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/users`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLocalUserRequestToJSON(requestParameters['createLocalUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Creates a single local authentication user in the specified tenant.  **What this does:** - Creates a user with local authentication (Keycloak) - Generates a secure password automatically - Assigns roles/groups based on request or tenant configuration - Sets preferred username/display name (or extracts from email if not provided) - Returns the generated password in the response for admin to share with user  **Password Handling:** - Passwords are NOT stored in this application\'s database - Passwords are only stored in Keycloak (identity provider) - The generated password is returned ONCE in the response - Supports temporary passwords (force reset on first login)  **Role Assignment (Optional, Mutually Exclusive with Groups):** - **Direct Role Assignment:** Provide `roleId` or `roleName` to assign a specific role - **Group-Based Assignment:** Provide `groupId` or `groupName` to add user to a group (inherits group roles) - **Default Assignment:** If no role/group specified, assigns tenant\'s default role - **Mutually Exclusive:** Cannot specify both role assignment AND group assignment in the same request - Priority: roleId > roleName > default  **Preferred Username (Optional):** - **Custom Username:** Provide `preferredUsername` to set a display name/username (e.g., \"jdoe\") - **Auto-Generated:** If not provided, extracts username from email (part before @) - Used for display purposes and can differ from email address  **Phone Number (Optional):** - **E.164 Format:** Provide `phoneNumber` in E.164 international format (e.g., \"+1-202-555-0173\", \"+44-20-7946-0958\") - **Validation:** Automatically normalized and validated - **Format:** +[country code][number] (hyphens/spaces allowed in input, normalized in storage)  **Extended Metadata (Optional):** - **Custom Fields:** Provide `metadata` as JSON object for tenant-specific custom fields - **Examples:** {\"department\": \"Engineering\", \"employeeId\": \"EMP-12345\", \"location\": \"New York\"} - **Storage:** Stored as JSONB in database for flexible schema extension  **Timezone Configuration (Optional):** - **Custom Timezone:** Provide `preferredTimezone` to override tenant default (e.g., \"America/New_York\") - **Tenant Default:** If not provided, uses tenant\'s configured default timezone - **System Default:** Falls back to UTC if tenant has no configured default  **Temporary Password Option:** - Set `temporaryPassword: true` to force password reset on first login - Set `temporaryPassword: false` (default) for permanent password  **Note:** This endpoint only works for local authentication users. SSO users are created automatically on first login via Just-In-Time (JIT) provisioning. 
     * Create local user
     */
    async createLocalUser(requestParameters: CreateLocalUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.createLocalUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivates a user account, preventing access to the system.  **What this does:** - Sets user.isActive = false - Deactivates all user-tenant associations - Prevents user from authenticating and accessing the system - Existing sessions may remain valid until they expire  **Use cases:** - Temporarily suspend user access - Disable account for security reasons - Remove access without deleting the user record  **Protection:** - Protected system users cannot be deactivated - Deactivation is audited for compliance  **Note:** For SSO users, deactivation in the identity provider is managed separately. This endpoint controls access within this application. To fully prevent SSO users from accessing the system, they must also be disabled in their identity provider. 
     * Deactivate user
     */
    async deactivateUserRaw(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deactivateUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}/deactivate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Deactivates a user account, preventing access to the system.  **What this does:** - Sets user.isActive = false - Deactivates all user-tenant associations - Prevents user from authenticating and accessing the system - Existing sessions may remain valid until they expire  **Use cases:** - Temporarily suspend user access - Disable account for security reasons - Remove access without deleting the user record  **Protection:** - Protected system users cannot be deactivated - Deactivation is audited for compliance  **Note:** For SSO users, deactivation in the identity provider is managed separately. This endpoint controls access within this application. To fully prevent SSO users from accessing the system, they must also be disabled in their identity provider. 
     * Deactivate user
     */
    async deactivateUser(requestParameters: DeactivateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.deactivateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a user
     * Delete user
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a user
     * Delete user
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific user by ID
     * Get user by ID
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific user by ID
     * Get user by ID
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current user\'s profile
     * Get user profile
     */
    async getUserProfileRaw(requestParameters: GetUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the current user\'s profile
     * Get user profile
     */
    async getUserProfile(requestParameters: GetUserProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.getUserProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves user\'s preferred timezone
     * Get user timezone
     */
    async getUserTimezoneRaw(requestParameters: GetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUserTimezone().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}/timezone`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves user\'s preferred timezone
     * Get user timezone
     */
    async getUserTimezone(requestParameters: GetUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUserTimezoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of users for the current tenant
     * Get users
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of users for the current tenant
     * Get users
     */
    async getUsers(requestParameters: GetUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserListResponse> {
        const response = await this.getUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resets a user\'s password.  **Local Authentication:** - Generates a new secure password (or uses provided password) - Updates password in identity provider (Keycloak) - Returns the new password in the response  **SSO Users:** - Password reset is not available for SSO users - Password management is handled by the identity provider (Azure AD, Okta, Google, etc.) - Users must reset passwords through their organization\'s SSO portal  **Security:** - Requires users:update permission - All password resets are audited - Passwords can be marked as temporary (force reset on next login) 
     * Reset user password
     */
    async resetUserPasswordRaw(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordResetResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resetUserPassword().'
            );
        }

        if (requestParameters['passwordResetRequest'] == null) {
            throw new runtime.RequiredError(
                'passwordResetRequest',
                'Required parameter "passwordResetRequest" was null or undefined when calling resetUserPassword().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/users/{id}/reset-password`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetRequestToJSON(requestParameters['passwordResetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetResponseFromJSON(jsonValue));
    }

    /**
     * Resets a user\'s password.  **Local Authentication:** - Generates a new secure password (or uses provided password) - Updates password in identity provider (Keycloak) - Returns the new password in the response  **SSO Users:** - Password reset is not available for SSO users - Password management is handled by the identity provider (Azure AD, Okta, Google, etc.) - Users must reset passwords through their organization\'s SSO portal  **Security:** - Requires users:update permission - All password resets are audited - Passwords can be marked as temporary (force reset on next login) 
     * Reset user password
     */
    async resetUserPassword(requestParameters: ResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordResetResponse> {
        const response = await this.resetUserPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates user information
     * Update user
     */
    async updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUser().'
            );
        }

        if (requestParameters['updateUserRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequest',
                'Required parameter "updateUserRequest" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Updates user information
     * Update user
     */
    async updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.updateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the current user\'s profile
     * Update user profile
     */
    async updateUserProfileRaw(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['updateUserRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequest',
                'Required parameter "updateUserRequest" was null or undefined when calling updateUserProfile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/users/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Updates the current user\'s profile
     * Update user profile
     */
    async updateUserProfile(requestParameters: UpdateUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.updateUserProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates user\'s preferred timezone
     * Update user timezone
     */
    async updateUserTimezoneRaw(requestParameters: UpdateUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUserTimezone().'
            );
        }

        if (requestParameters['timezoneId'] == null) {
            throw new runtime.RequiredError(
                'timezoneId',
                'Required parameter "timezoneId" was null or undefined when calling updateUserTimezone().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['timezoneId'] != null) {
            queryParameters['timezoneId'] = requestParameters['timezoneId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/users/{id}/timezone`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
    }

    /**
     * Updates user\'s preferred timezone
     * Update user timezone
     */
    async updateUserTimezone(requestParameters: UpdateUserTimezoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponse> {
        const response = await this.updateUserTimezoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
